import { useQuery } from '@tanstack/react-query';

import { IGetWarehouseDocumentsParams } from '@app/models/interfaces';
import Api from '@app/services/api';

export const useGetWarehouseDocumentsQuery = ({ warehouse_uid, ...params }: IGetWarehouseDocumentsParams) => {
  return useQuery({
    queryKey: ['getWarehouseDocuments', warehouse_uid, params],
    queryFn: () => Api.wms.getWarehouseDocuments({ warehouse_uid, ...params }),
    enabled: !!warehouse_uid,
  });
};
